import { BackButton } from '@library/buttons';
import GridwallRequestDetail from 'modules/gridwall-requests/components/GridwallRequestDetail/GridwallRequestDetail';
import GridwallRequestList from 'modules/gridwall-requests/components/GridwallRequestList/GridwallRequestList';
import useGridwallRequestData from 'modules/gridwall-requests/hooks/useGridwallData';
import useGridwallRequestListData from 'modules/gridwall-requests/hooks/useGridwallListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useParams } from 'react-router-dom';

const GridwallRequestDetailPage = () => {
    const { gridwallId } = useParams();
    const { gridwallRequest, isLoading } = useGridwallRequestData({ gridwallId });

    return (
        <PageTemplate>
            <PageHeading className="flex justify-between items-center">
                <div>
                    <BackButton />
                    <div className="mt-2">Gridwall Request</div>
                </div>
            </PageHeading>

            <div className="mt-4">
                <GridwallRequestDetail isLoading={isLoading} gridwall={gridwallRequest} />
            </div>
        </PageTemplate>
    );
};

export default GridwallRequestDetailPage;
